var exports = {
  "e0": "ProductAnnouncementModalDesktop__wSCzDA",
  "sO": "ProductAnnouncementModalDesktop__closeButton__5Tl526",
  "S5": "ProductAnnouncementModalDesktop__sidebar__SKNFls",
  "Oh": "ProductAnnouncementModalDesktop__sidebar-content__QK32-M",
  "Pu": "ProductAnnouncementModalDesktop__sidebar-items__BN-tDv",
  "wS": "ProductAnnouncementModalDesktop__sidebar-item__VmAURR",
  "_Z": "ProductAnnouncementModalDesktop__sidebar-indicator__eVRKgP",
  "LK": "ProductAnnouncementModalDesktop__sidebar-seeAll__nOtMTN",
  "U0": "ProductAnnouncementModalDesktop__sidebar-ctas__KfqME3",
  "dC": "ProductAnnouncementModalDesktop__sidebar-ctas--stacked__BpmV8y",
  "He": "ProductAnnouncementModalDesktop__content__RxpkBB",
  "y$": "ProductAnnouncementModalDesktop__content-visual__9ygQkP",
  "K9": "ProductAnnouncementModalDesktop__content-items__CNlCN5",
  "NZ": "ProductAnnouncementModalDesktop__header__dBpRH_",
  "cv": "ProductAnnouncementModalDesktop__label__qr9eJc",
  "aF": "ProductAnnouncementModalDesktop__body__Ltnv89",
  "wL": "ProductAnnouncementModalDesktop--security__C2tjBt",
};

module.exports = exports;
